import { render } from "./DeepSeaDots.vue?vue&type=template&id=75032110&scoped=true"
const script = {}

import "./DeepSeaDots.vue?vue&type=style&index=0&id=75032110&lang=scss&scoped=true"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75032110"]])

export default __exports__